import { Tooltip } from 'Storybook/components/local/Tooltip/Tooltip';
import { TooltipAnchor, TooltipAnchorProps } from 'Storybook/components/local/Tooltip/TooltipAnchor';

import styles from './InputLabel.module.scss';

type InputLabelProps<T extends React.ReactNode> = {
  anchorProps?: TooltipAnchorProps;
  labelText?: T;
  onTooltipShow?: () => void;
  tooltip?: T;
  tooltipSibling?: React.ReactNode;
};

export const InputLabel = <T extends React.ReactNode, >({
  anchorProps,
  labelText,
  onTooltipShow,
  tooltip,
  tooltipSibling,
}: InputLabelProps<T>) => {
  const Anchor = <TooltipAnchor {...anchorProps} />;
  const child = tooltipSibling ? <span>{tooltipSibling}{Anchor}</span> : Anchor;

  return (
    <div className={styles.inputLabelContainer}>
      <span className={styles.labelText}>{labelText}</span>
      {tooltip && <Tooltip
        onShow={onTooltipShow}
        overlay={<div>
          {tooltip}
        </div>}
        placement="top"
      >
        {child}
      </Tooltip>}
    </div>
  );
};
